/* import __COLOCATED_TEMPLATE__ from './ic-attribute-item-with-user-event.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/require-computed-property-dependencies */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable ember/require-computed-macros */
/* eslint-disable ember/use-brace-expansion */
/* eslint-disable @intercom/intercom/use-es5-getters */
import Component from '@ember/component';
import EmberObject, { action, computed } from '@ember/object';
import { match } from '@ember/object/computed';
import { schedule } from '@ember/runloop';
export default Component.extend({
  tagName: '',
  itemElement: null,
  didReceiveAttrs() {
    this._super(...arguments);
    this.set('isUserEventOptionsOpen', false);
  },
  isEventAttribute: match('item.value', /^user_event_summaries\./),
  shouldRenderTooltip: computed('item.descriptionForTooltip', 'truncated', function () {
    return this.get('item.descriptionForTooltip') || this.get('item.isDisabled') || this.get('truncated');
  }),
  handleClick: action(function (e) {
    if (this.get('item.isDisabled')) {
      e.stopPropagation();
      e.preventDefault();
      return;
    }
    if (this.isEventAttribute) {
      e.stopPropagation();
    }
    this.addAttributeOrToggleEventOptions(this.get('item.value'));
  }),
  addAttributeOrToggleEventOptions: action(function () {
    if (this.isEventAttribute) {
      this.toggleProperty('isUserEventOptionsOpen');
      schedule('afterRender', () => {
        if (this.isDestroying) {
          return;
        }
        this.itemElement.querySelector('.ds-new__event__options [role^=menuitem]')?.focus();
      });
    } else {
      this.selectItem(this.item, this.get('item.value'));
    }
  }),
  addEventAttribute: action(function (eventType) {
    let type = eventType === 'count' ? 'integer' : 'date';
    let attribute = EmberObject.create({
      identifier: `${this.get('item.value')}.${eventType}`,
      type: `user_event_${type}`
    });
    let clonedItemWithValue = Object.assign({}, this.item, {
      value: attribute
    });
    let item = EmberObject.create(clonedItemWithValue);
    this.selectItem(item);
  }),
  setupElement: action(function (element) {
    this.set('itemElement', element);
  }),
  checkForTruncation: action(function (element) {
    if (element) {
      this.set('truncated', element.offsetWidth < element.scrollWidth);
    } else {
      this.set('truncated', false);
    }
  })
});